/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Root_Team_LabelInputs */



/**
* | output |
* | --- |
* | "Team Drive" |
*
* @param {Explorer_Root_Team_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_root_team_label = /** @type {((inputs?: Explorer_Root_Team_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Root_Team_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drive d'equipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team Drive")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida di squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Командное движение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unidad de equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队驱动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームドライブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम ड्राइव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Equipe Drive")
	return /** @type {LocalizedString} */ ("Team Drive")
});